<div class="app-wrapper" *ngIf="access">
    <nav class="tab_navigation">
        &nbsp;
    </nav>
    <section class="main-content settings-section workflows-section">
        <div class="app-main">
            <header>
                <div class="data-header">
                  <core-title-section
                    [title]="'Workflows'"
                    [description]="'Here you can manage your workflow configuration.'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="button-settings-add">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                    <!-- <core-helpers-forms-button-icon [text]="'ADD A NEW WORKFLOW'" [icon]="'add'" (click)="showForm = !showForm"></core-helpers-forms-button-icon> -->
                  </div>
                </div>
            </header>
            <div class="workflows-add" [hidden]="!showForm">
                <settings-workflows-add-form (cancel)="showForm = false" (submit)="onSaved($event)"></settings-workflows-add-form>
            </div>
            <div class="box_default box_white workflows-list">
                <div *ngIf="status == STATUS_DONE">
                    <h3><span>ALL WORKFLOWS</span></h3>
                    <ul class="workflows-ul">
                        <core-helpers-lists-one-action-list-item
                            *ngFor="let workflow of workflows | sortByActive "
                            [title]="workflow.name"
                            (titleClick)="onSelect(workflow)"
                            [actionText]="workflow.active? 'Deactivate' : 'Activate'"
                            (actionClick)="workflow.active? deactivate(workflow) : activate(workflow)"
                            [type]="workflow.active? 'disabled': 'inactive'"
                        ></core-helpers-lists-one-action-list-item>
                    </ul>
                </div>
                <div class="loader">
                    <div class="dimmed" [hidden]="status == STATUS_DONE">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_flex">
                            <div class="dimmed_box"></div>
                            <div class="dimmed_subtitle"></div>
                        </div>
                        <div class="dimmed_flex">
                            <div class="dimmed_box"></div>
                            <div class="dimmed_subtitle"></div>
                        </div>
                        <div class="dimmed_flex">
                            <div class="dimmed_box"></div>
                            <div class="dimmed_subtitle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
